export default "__VITE_ASSET__CzfMdciC__"